import { testimonials, timelineGuides } from "@/mocks/chigua";

export default function BrandSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 关于 / 理念 */}
        <div className="grid lg:grid-cols-12 gap-8 items-center mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
              <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
              关于在线吃瓜
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-snug">
              把「吃瓜」做成一件
              <span className="text-primary-600">认真且体面</span>的事
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              在信息爆炸的时代,热点转瞬即逝,真相常被情绪淹没。在线吃瓜想做的是给那些「想真正看懂」的读者,
              一个可以慢下来、按图索骥的入口。我们用完整时间线还原事件始末,用前因后果解析交代背景,
              用深度复盘区分事实与观点。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们不制造焦虑,不标题党,不替你站队。我们相信,只有当信息被逐层拆解、来龙去脉足够清晰时,
              每个人才能看清事件全貌,并作出自己的判断。
            </p>
            <div className="mt-6 grid grid-cols-3 gap-3 max-w-lg">
              {[
                { n: "真实优先", d: "一手信源核实" },
                { n: "理性克制", d: "不煽动不站队" },
                { n: "持续更新", d: "事件有始有终" },
              ].map((v) => (
                <div key={v.n} className="rounded-xl bg-background-100 border border-background-200 p-4">
                  <p className="font-heading text-base font-bold text-foreground-900">{v.n}</p>
                  <p className="text-xs text-foreground-500 mt-1">{v.d}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 栏目卡片 */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {timelineGuides.map((g, i) => (
              <a
                key={g.key}
                href="#hot"
                className={
                  "rounded-xl p-5 border flex flex-col justify-between min-h-[128px] transition-transform hover:-translate-y-1 " +
                  (i % 2 === 0
                    ? "bg-primary-500 border-primary-500"
                    : "bg-background-100 border-background-200")
                }
              >
                <div>
                  <span
                    className={
                      "w-9 h-9 rounded-md flex items-center justify-center text-lg " +
                      (i % 2 === 0
                        ? "bg-background-50/20 text-background-50"
                        : "bg-accent-100 text-accent-800")
                    }
                  >
                    <i className="ri-folder-5-line" aria-hidden="true"></i>
                  </span>
                  <h4
                    className={
                      "font-heading text-lg font-bold mt-3 " +
                      (i % 2 === 0 ? "text-background-50" : "text-foreground-900")
                    }
                  >
                    {g.label}
                  </h4>
                  <p
                    className={
                      "text-xs mt-1 " +
                      (i % 2 === 0 ? "text-background-100" : "text-foreground-500")
                    }
                  >
                    {g.desc}
                  </p>
                </div>
                <span
                  className={
                    "text-xs mt-3 " + (i % 2 === 0 ? "text-accent-200" : "text-secondary-700")
                  }
                >
                  {g.count} · 前往瓜田
                </span>
              </a>
            ))}
          </div>
        </div>

        {/* 用户口碑 */}
        <div>
          <div className="text-center max-w-2xl mx-auto mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              读者怎么说
            </h2>
            <p className="mt-3 text-sm text-foreground-500">
              感谢每一位愿意耐心看懂完整脉络的你,我们认真对待每一份阅读。
            </p>
          </div>
          <div className="grid sm:grid-cols-3 gap-5">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-xl bg-background-100 border border-background-200 p-6 flex flex-col"
              >
                <span className="text-primary-500 flex items-center gap-0.5 text-sm mb-3" aria-label="五星好评">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill" aria-hidden="true"></i>
                  ))}
                </span>
                <blockquote className="flex-1 text-sm text-foreground-700 leading-relaxed">
                  「{t.text}」
                </blockquote>
                <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-secondary-200 text-secondary-800 flex items-center justify-center text-sm font-medium">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}